var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.initialized
        ? _c("div", {
            staticStyle: {
              height: "100vh",
              position: "absolute",
              left: "55%",
              top: "10%"
            }
          })
        : [
            _c(
              "b-card",
              { staticStyle: { height: "100vh" }, attrs: { "no-body": "" } },
              [
                _c("div", { staticClass: "tabs" }, [
                  _c(
                    "div",
                    {
                      class: [
                        "card-header",
                        _vm.sections.length == 1 ? "hide" : ""
                      ]
                    },
                    [
                      _c(
                        "ul",
                        {
                          staticClass: "nav nav-tabs card-header-tabs",
                          attrs: { role: "tablist", tabindex: "0" }
                        },
                        _vm._l(_vm._.slice(_vm.sections, 1), function(section) {
                          return _vm.isSectionEnabled(
                            _vm.topLevelType,
                            section.name
                          )
                            ? _c(
                                "li",
                                {
                                  key: section.name + section.link,
                                  class: ["nav-item"],
                                  attrs: { role: "presentation" }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      class: [
                                        "nav-link",
                                        section.active ? "active" : ""
                                      ],
                                      attrs: { role: "tab", tabindex: "-1" },
                                      on: {
                                        click: function($event) {
                                          return _vm.changeTab(section)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.__(
                                              section.label || section.name,
                                              ["titleCase"]
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tab-content tab-content-shadow p-2" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tab-pane card-body show fade active",
                          staticStyle: { "min-height": "2rem" },
                          attrs: { role: "tabpanel" }
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-sm-6" }, [
                              _c("h2", { staticClass: "content-header" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm._.chain(_vm.breadcrumb)
                                        .last()
                                        .get("label")
                                        .value() ||
                                        _vm._.chain(_vm.breadcrumb)
                                          .last()
                                          .get("name")
                                          .str(["titleCase"])
                                          .value()
                                    ) +
                                    "\n                                "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.breadcrumbDisplay
                                ? _c(
                                    "ul",
                                    { staticClass: "breadcrumb" },
                                    [
                                      _vm._l(_vm.breadcrumb, function(node) {
                                        return [
                                          node.link
                                            ? _c(
                                                "li",
                                                { key: node.name + node.link },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.changeBreadcrumbLink(
                                                            node.link
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          node.label ||
                                                            _vm.__(node.name, [
                                                              "titleCase"
                                                            ])
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "li",
                                                { key: node.name + node.link },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      node.label ||
                                                        _vm.__(node.name, [
                                                          "titleCase"
                                                        ])
                                                    )
                                                  )
                                                ]
                                              )
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-sm-6 text-right" },
                              [
                                _c("content-toolbar-component", {
                                  attrs: {
                                    content: _vm.localContent,
                                    timestamp: _vm.localTimestamp,
                                    dirty: _vm.dirty,
                                    contentErrors: _vm.contentErrors,
                                    selected: _vm.selected,
                                    changeUrl: _vm.changeUrl,
                                    changeQuery: _vm.changeQuery,
                                    changeSection: _vm.changeSection,
                                    componentName: _vm.componentName,
                                    componentConfig: _vm.componentConfig,
                                    haltFetch: _vm.signalHaltFetch,
                                    createData: _vm.createDataPostMessage,
                                    updateBatch: _vm.updateBatchPostMessage,
                                    updateData: _vm.updateDataPostMessage,
                                    deleteData: _vm.deleteDataPostMessage,
                                    commitQueue: _vm.commitQueue,
                                    updateParent: _vm.updateParent,
                                    addNotification: _vm.addNotification
                                  },
                                  on: {
                                    "content::creating": _vm.loadNewInstance,
                                    "content::created": _vm.doNothing,
                                    "content::updated": _vm.resetLocalState,
                                    "content::deleted": _vm.backToCollection
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "tab-pane card-body show fade active",
                                attrs: { role: "tabpanel" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "p-3" },
                                  [
                                    _vm.getComponentForType(_vm.fulltype)
                                      ? _c(
                                          _vm.getComponentForType(_vm.fulltype),
                                          _vm._b(
                                            {
                                              key: _vm.resourcePath,
                                              tag: "component",
                                              attrs: {
                                                loading: _vm.loading,
                                                getData: _vm.getData,
                                                createData:
                                                  _vm.createDataPostMessage,
                                                updateBatch:
                                                  _vm.updateBatchPostMessage,
                                                updateData:
                                                  _vm.updateDataPostMessage,
                                                deleteData:
                                                  _vm.deleteDataPostMessage,
                                                replaceData: _vm.replaceData,
                                                changeUrl: _vm.changeUrl,
                                                changeQuery: _vm.changeQuery,
                                                changeSection:
                                                  _vm.changeSection,
                                                addNotification:
                                                  _vm.addNotification,
                                                haltFetch: _vm.signalHaltFetch,
                                                commitQueue: _vm.commitQueue,
                                                query: _vm.query,
                                                timestamp: _vm.timestamp,
                                                content: _vm.localContent,
                                                resourceParams:
                                                  _vm.resourceParams
                                              },
                                              on: {
                                                "content::initialized":
                                                  _vm.updateComponent,
                                                "content::creating":
                                                  _vm.loadNewInstance,
                                                "content::created":
                                                  _vm.doNothing,
                                                "content::updated":
                                                  _vm.resetLocalState,
                                                "content::changed":
                                                  _vm.updateLocalContentPostMessage,
                                                "content::deleted":
                                                  _vm.backToCollection,
                                                "content::selected":
                                                  _vm.updateSelected
                                              }
                                            },
                                            "component",
                                            _vm.getConfigForType(_vm.fulltype),
                                            false
                                          )
                                        )
                                      : _c("content-view-component", {
                                          attrs: {
                                            type: _vm.fulltype,
                                            loading: _vm.loading,
                                            showLoading:
                                              _vm.currentSection !==
                                              _vm.previousSection,
                                            getData: _vm.getData,
                                            createData:
                                              _vm.createDataPostMessage,
                                            updateBatch:
                                              _vm.updateBatchPostMessage,
                                            updateData:
                                              _vm.updateDataPostMessage,
                                            deleteData:
                                              _vm.deleteDataPostMessage,
                                            changeUrl:
                                              _vm.changeUrlForSubSection,
                                            changeQuery: _vm.changeQuery,
                                            changeSection: _vm.changeSection,
                                            addNotification:
                                              _vm.addNotification,
                                            commitQueue: _vm.commitQueue,
                                            pushQueue: _vm.pushQueue,
                                            selected: _vm.selected,
                                            resourceParams: _vm.resourceParams,
                                            section: _vm.section,
                                            content: _vm.localContent,
                                            parent: _vm.parent,
                                            timestamp: _vm.timestamp,
                                            query: _vm.query,
                                            contentType: _vm.contentType,
                                            relationship: _vm.relationship,
                                            haltFetch: _vm.signalHaltFetch
                                          },
                                          on: {
                                            "content::initialized":
                                              _vm.updateComponent,
                                            "content::creating":
                                              _vm.loadNewInstance,
                                            "content::created": _vm.doNothing,
                                            "content::updated":
                                              _vm.resetLocalState,
                                            "content::changed":
                                              _vm.updateLocalContentPostMessage,
                                            "content::deleted":
                                              _vm.backToCollection,
                                            "content::selected":
                                              _vm.updateSelected
                                          }
                                        })
                                  ],
                                  1
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-sm-6 text-right" },
                              [
                                _c("content-toolbar-component", {
                                  attrs: {
                                    content: _vm.localContent,
                                    timestamp: _vm.localTimestamp,
                                    dirty: _vm.dirty,
                                    contentErrors: _vm.contentErrors,
                                    selected: _vm.selected,
                                    changeUrl: _vm.changeUrl,
                                    changeQuery: _vm.changeQuery,
                                    changeSection: _vm.changeSection,
                                    componentName: _vm.componentName,
                                    componentConfig: _vm.componentConfig,
                                    haltFetch: _vm.signalHaltFetch,
                                    createData: _vm.createDataPostMessage,
                                    updateBatch: _vm.updateBatchPostMessage,
                                    updateData: _vm.updateDataPostMessage,
                                    deleteData: _vm.deleteDataPostMessage,
                                    commitQueue: _vm.commitQueue,
                                    updateParent: _vm.updateParent,
                                    addNotification: _vm.addNotification
                                  },
                                  on: {
                                    "content::creating": _vm.loadNewInstance,
                                    "content::created": _vm.doNothing,
                                    "content::updated": _vm.resetLocalState,
                                    "content::deleted": _vm.backToCollection
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ])
              ]
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42b96d08", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42b96d08","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/PageEditorComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-42b96d08","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/PageEditorComponent.vue
// module chunks = 0